import React, { FC } from 'react';
import styled from 'styled-components';

import { Cycle } from '~/api/book/cycleApiTypes';
import { Divider } from '~/atomic/atom/Divider';

import { BookList } from './BookList';
import { CycleTitle } from './CycleTitle';

export const AuthorCycle: FC<{ cycle: Cycle }> = ({ cycle }) => {
  if ((cycle?.books?.length ?? 0) === 0) return null;

  return (
    <SCAuthorCycle>
      <Divider />
      <CycleTitle cycle={cycle} />
      <BookList books={cycle.books} />
    </SCAuthorCycle>
  );
};

const SCAuthorCycle = styled.div``;
